import React, { useState } from 'react';
import { Chart } from 'primereact/chart';

const LeaveBalanceChart = ({ data, options }) => {

    return (
        <div style={{ width: '100%' }}>
            <Chart type="bar" data={data} options={options} />
        </div>
    )
}

export default LeaveBalanceChart